import { Badge } from 'antd';
import { useTranslation } from 'react-i18next';

export interface IUnreadCountBadgeProps {
  count: number;
}

/**
 * Badge presentazionale con il numero di comunicazioni non lette,
 * mostrato accanto al titolo della scheda "Comunicazioni". Non rende
 * nulla quando il conteggio è zero.
 */
export function UnreadCountBadge(props: IUnreadCountBadgeProps) {
  const { count } = props;
  const { t } = useTranslation();

  if (!count) return null;

  const ariaLabel = t(
    'communication.unread-count',
    '{{count}} comunicazioni non lette',
    { count },
  );

  return (
    <Badge count={count} size="small" offset={[4, -4]} aria-label={ariaLabel} />
  );
}
